import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { ExportViewProps, ExportViewRef } from "./models";
import SearchFilter, { Filters } from "../../../Common/SearchFilter/SearchFilter";
import { searchFilterToExportExcelFilter } from "../../../Common/SearchFilter/utils";
import useDidMountEffect from "../../../Common/UseDidMountEffect";
import { ApiBackend } from "../../../../providers/apibackend";
import { Event } from "../../../../model/Event";

type SearchFilterType = {
    hadEntry?: boolean;
    hadEntryEventId?: string;
    noEntry?: boolean;
    noEntryEventId?: string;
};

interface ISearchFilter {
    hadEntry?: boolean;
    hadEntryEventId?: string;
    noEntry?: boolean;
    noEntryEventId?: string;
}

const B2BAdmins = forwardRef<ExportViewRef, ExportViewProps>((props, ref) => {
    const [searchFilter, setSearchFilter] = useState(null as ISearchFilter);
    const [events, setEvents] = useState(null as Event[]);

    useImperativeHandle(ref, () => ({
        isValid: () => {
            return true;
        }
    }));

    useEffect(() => {
        new ApiBackend().listEvents().then((res) => {
            setEvents(res);
        });
    }, []);

    useDidMountEffect(() => {
        props.onChange(searchFilterToExportExcelFilter<ISearchFilter>(searchFilter));
    }, [searchFilter]);

    const eventItems = events == null ? [] : events.map(x => { return { name: x.name, value: x.id } });

    const render = () => {
        return (
            <SearchFilter<SearchFilterType>
                id={"export-b2badmins-filter"}
                filters={{
                    "hadEntry": {
                        id: "filter-hadentry",
                        type: "Checkbox",
                        label: "Hade anmälan till evenemang",
                        size: 12,
                    },
                    "hadEntryEventId": {
                        id: "filter-hadentry-event",
                        type: "GenericSelect",
                        label: "Evenemang (hade anmälan till)",
                        size: 12,
                        multiple: false,
                        itemDefinition: {
                            items: eventItems,
                            itemValueType: "string"
                        }
                    },
                    "noEntry": {
                        id: "filter-noentry",
                        type: "Checkbox",
                        label: "Har inte anmälan till evenemang",
                        size: 12,
                    },
                    "noEntryEventId": {
                        id: "filter-noentry-event",
                        type: "GenericSelect",
                        label: "Evenemang (saknar anmälan till)",
                        size: 12,
                        multiple: false,
                        itemDefinition: {
                            items: eventItems,
                            itemValueType: "string"
                        }
                    },
                }}
                persist={true}
                onInit={(filter: Filters<SearchFilterType>) => {
                    setSearchFilter(filter as unknown as ISearchFilter);
                }}
                onChange={(filter: Filters<SearchFilterType>) => {
                    setSearchFilter(filter as unknown as ISearchFilter);
                }}
            />
        );
    };

    return render();
});

export default B2BAdmins;
